import React from 'react';
import { DateTime } from 'luxon';
import { useTranslation } from "../../../../hooks/useTranslation";
import { makeStyles, useAuth } from "../../../../index";
import { WorkItem } from "./WorkItem";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        maxWidth: 1366,
        width: '100%',
        padding: theme.spacing(0, 3, 1, 3),
    },
    item: {
        paddingBottom: theme.spacing(0.5),
    },
}); });
export var WorkItems = function (props) {
    var works = props.works, sortItem = props.sortItem, selectedWorkId = props.selectedWorkId, selectable = props.selectable, onSelectWork = props.onSelectWork;
    var classes = useStyles();
    var t = useTranslation().t;
    var user = useAuth().user;
    var getDatetimeInfo = function (createdDatetime, updatedDatetime) {
        // ワークにおいて作成直後の状態では作成日時=更新日時となり、更新日時(updatedDatetime)がundefinedである
        var _a = sortItem === 'create_datetime' ? ['作成', createdDatetime] : ['更新', updatedDatetime || createdDatetime], label = _a[0], datetime = _a[1];
        return {
            label: label,
            datetime: datetime.toFormat(DateTime.local().get('year') === datetime.get('year')
                ? t('LL月dd日 HH:mm')
                : t('yyyy年LL月dd日')),
        };
    };
    if (user == null)
        return null;
    return (React.createElement("div", { className: classes.root }, works.map(function (work) {
        return (React.createElement("div", { className: classes.item, key: work.id },
            React.createElement(WorkItem, { id: work.id, name: work.name, drillType: work.drillType, isCreator: work.creatorId === user.userId, selected: selectedWorkId.some(function (id) { return id === work.id; }), selectable: selectable, creatorName: work.creatorName, datetimeInfo: getDatetimeInfo(work.createdDatetime, work.updatedDatetime), onSelectWork: function () {
                    return onSelectWork(work, selectedWorkId.some(function (id) { return id === work.id; }));
                } })));
    })));
};
